<script setup>
import { defineProps } from "vue"
import { Gems } from "../gems";

const props = defineProps({
  count: {
    type: [Number, String],
    default: 0
  },
  icon: {
    type: String,
    default: ''
  },
  tooltip: {
    type: String,
    default: ''
  }
})

</script>

<template>
    <div class="div-notification" v-if="props.count > 0" @mouseenter="Gems.Tooltip($event.target, tooltip, 'tooltip')">
        <i class="fas icon-size" :class="`fa-${icon}`"></i>
        <div class="nofication-container">
            <span class="div-comments-count">{{ props.count }}</span>
        </div>
    </div>
</template>

<style scoped>
    .nofication-container {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -3px;
        left: 10px;
        width: 14px !important;
        height: 14px !important;
        border-radius: 50%;
        background-color: red;
        color: white;
        font-size: 0.6em;
        text-align: center;
    }

    .icon-size {
        font-size: 12pt;
    }

    .div-notification {
        position: relative;
        margin-left: 10px;
    }

    .div-comments-count {
        padding: 0;
        font-size: 7pt;
        margin: 0 auto;
        top: 0;
        bottom: 0;
    }
</style>